// Phase 25 iter-3 — "Vender un animal": páxina de instrución, NON
// formulario de listing. En chain a operación de pór un animal á venda
// faise dende a app móbil (o gandeiro selecciona o animal real, asina
// a oferta co seu material ECDSA, configura prezo/subasta) e o
// marketplace web é só o escaparate para compradores. Esta páxina
// explica iso e empurra a descarga da app.

import { ArrowRight, Beef, Gavel, Smartphone, ShieldCheck, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useAuthContext } from '../context/AuthContext';

const STEPS = [
  {
    icon: Smartphone,
    title: '1 · Abre LeyroChain no teu móbil',
    body: 'Vai aos teus animais e selecciona o que queres vender. Se aínda non tes a app, descárgaa nesta páxina.',
  },
  {
    icon: Sparkles,
    title: '2 · Configura a venda',
    body: 'Escolle modalidade — Prezo fixo ou Subasta con prezo de arranque — e datas. Cando confirmas, asinas o anuncio coa túa identidade.',
  },
  {
    icon: ShieldCheck,
    title: '3 · O comprador ve o historial completo',
    body: 'Cada animal aparece no marketplace con vacinas, traslados, peso e propietarios — todo ancorado en Polygon. Os compradores que confíen ofrecen ou mercan.',
  },
  {
    icon: Beef,
    title: '4 · Recolle o pagamento',
    body: 'Cando un comprador reserva ou gana a subasta, recibes notificación. Coordinades a recollida ou o transporte; o cobro chega á túa conta bancaria de forma automática.',
  },
];

export default function SellAnimalPage(): JSX.Element {
  const { user } = useAuthContext();
  const isFarmer = !!user?.roles.includes('FARMER');

  return (
    <main className="max-w-5xl mx-auto px-6 py-12">
      <header className="max-w-3xl mb-10">
        <span className="inline-flex items-center gap-1 text-xs uppercase tracking-wider font-bold text-rauxa bg-rauxa/10 rounded-full px-3 py-1">
          <Gavel size={14} /> Para gandeiros
        </span>
        <h1 className="text-4xl font-extrabold text-dark mt-4 leading-tight">Vender un animal</h1>
        <p className="mt-4 text-lg text-muted leading-relaxed">
          A venda configúrase desde a <strong className="text-dark">app móbil</strong> de LeyroChain
          — non desde a web. Así garantizamos que quen pon un animal á venda é o seu propietario
          real e que a información trazable (peso, vacinas, traslados) chega ao comprador sen
          intermediarios.
        </p>
      </header>

      {!isFarmer && (
        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-5 mb-10">
          <p className="text-sm text-amber-900">
            <strong>Necesitas un rol de Gandeiro</strong> para vender. Se xa o tes, abre a app móbil
            e atópalo no selector de rol. Se non, contacta connosco para activarcho na túa conta.
          </p>
        </div>
      )}

      <ol className="space-y-4">
        {STEPS.map((s) => {
          const Icon = s.icon;
          return (
            <li
              key={s.title}
              className="flex items-start gap-4 border border-border rounded-2xl p-5 bg-white"
            >
              <div className="w-12 h-12 rounded-2xl bg-rauxa/10 text-rauxa flex items-center justify-center shrink-0">
                <Icon size={22} />
              </div>
              <div className="flex-1">
                <h2 className="font-semibold text-dark">{s.title}</h2>
                <p className="text-sm text-muted mt-1 leading-relaxed">{s.body}</p>
              </div>
            </li>
          );
        })}
      </ol>

      <section className="mt-12 rounded-3xl bg-rauxa text-white p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex-1">
          <h2 className="text-2xl font-bold">Descarga LeyroChain no teu Android</h2>
          <p className="mt-2 text-white/90 max-w-lg">
            A app está dispoñíbel para Android (versión iOS na lista de espera). Crea a túa
            explotación, asocia LeyroSpot ás vacas e empeza a vender.
          </p>
        </div>
        <a
          href="/download/leyrochain.apk"
          className="inline-flex items-center gap-2 bg-white text-rauxa font-semibold rounded-full px-6 py-3 hover:bg-white/90 transition-colors whitespace-nowrap"
        >
          Descargar APK <ArrowRight size={18} />
        </a>
      </section>

      <p className="text-center text-sm text-muted mt-10">
        Buscas comprar?{' '}
        <Link to="/marketplace" className="text-rauxa font-semibold hover:underline">
          Explora o catálogo →
        </Link>
      </p>
    </main>
  );
}
